export default __webpack_public_path__ + "static/media/bank-transfer.add8a051.svg";